/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Invalid_CombinationInputs */

const en_issue_invalid_combination = /** @type {(inputs: Issue_Invalid_CombinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not a valid combination of gender, category and subcategory`)
};

/**
* | output |
* | --- |
* | "not a valid combination of gender, category and subcategory" |
*
* @param {Issue_Invalid_CombinationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_invalid_combination = /** @type {((inputs?: Issue_Invalid_CombinationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Invalid_CombinationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_invalid_combination(inputs)
});